export default __webpack_public_path__ + "static/media/footer_line.6b5bd51e.svg";